<svg preserveAspectRatio="none" overflow="visible" style="display: block;" width="29.5508" height="29.5508" viewBox="0 0 29.5508 29.5508" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="pain point">
<g id="Ellipse 251" filter="url(#filter0_f_0_150)">
<circle cx="14.7754" cy="14.7754" r="6.89518" fill="#CA1A1A" fill-opacity="0.72"/>
</g>
<g id="Ellipse 252">
<circle cx="14.7791" cy="14.7756" r="4.92513" fill="#D52222" fill-opacity="0.1"/>
<circle cx="14.7791" cy="14.7756" r="4.82099" stroke="#FFB4B4" stroke-opacity="0.52" stroke-width="0.208279"/>
</g>
<circle id="Ellipse 253" cx="14.7763" cy="14.7776" r="2.78323" fill="#D52222" fill-opacity="0.36" stroke="#FF7A7A" stroke-width="0.208279"/>
<circle id="Ellipse 254" cx="14.7785" cy="14.7757" r="0.604279" fill="#D52222" stroke="#FF7A7A" stroke-width="0.208279"/>
</g>
<defs>
<filter id="filter0_f_0_150" x="0" y="0" width="29.5508" height="29.5508" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
<feGaussianBlur stdDeviation="3.9401" result="effect1_foregroundBlur_0_150"/>
</filter>
</defs>
</svg>
